import apiClient from "@/shared/api/apiClient4";

export const StepRunList = async (notary_transaction_id, params) => {
  try {
    const { data } = await apiClient.get(
      `/step-runs/by-notary/${notary_transaction_id}/v2`,
      {
        params,
      }
    );
    return data;
  } catch (e) {
    console.error("StepRunList failed", e);
  }
};

export const createStepRun = async (params) => {
  const result = await apiClient.post(
    `/step-runs/init/v2`,
    {
      ...params,
    },
    {
      metaData: { isNotificationDisabled: true },
    }
  );
  return result.data;
};
